globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Statistics = appCustomerSpace.Controllers.Statistics || {};

appCustomerSpace.Controllers.Statistics.GoogleMyBusinessPerformanceController = (function(superClass) {

    utils.extend(GoogleMyBusinessPerformanceController, superClass);

    function GoogleMyBusinessPerformanceController() {
        return GoogleMyBusinessPerformanceController.__super__.constructor.apply(this, arguments);
    }

    $.extend(GoogleMyBusinessPerformanceController.prototype, {
        init: function(){
            this.initEvents();

            return GoogleMyBusinessPerformanceController.__super__.init.apply(this, arguments);
        },
        initEvents: function(){
            var me                   = this,
            $statisticsContainer = $('#highcharts-container'),
            ajaxUrl              = $statisticsContainer.data('ajax-url'),
            errorMsg             = 'Erreur de chargement des statistiques Google',
            queryString          = window.location.search;

            appCustomerSpace.Loader().start({ $container: $('.content-wrapper') });

            if(ajaxUrl) {
                $.get(ajaxUrl + queryString, function(data) {
                    if(data.response) {
                        appCustomerSpace.Loader().stop({ $container: $('.content-wrapper') }, function() {
                            $statisticsContainer.append(data.html);
                            $statisticsContainer.find("[data-popup=tooltip]").tooltip();
                            me.dateRangePicker(data);
                            me.displayCharts();
                            me.displayQueriesChartLegend();
                        });
                    } else {
                        alert(errorMsg);
                    }
                }).fail(function() {
                    alert(errorMsg);
                });
            } else {
                appCustomerSpace.Loader().stop({ $container: $('.content-wrapper') });
            };
        },
        displayQueriesChartLegend: function(){
            var me  = this,
                $chart = $('#location-queries-chart');
                defaultHtml = $chart.find('.highcharts-title').html(),
                queriesDirect = $chart.data('queries-direct'),
                queriesIndirect = $chart.data('queries-indirect'),
                directPercentage = Math.round(((queriesDirect / (queriesDirect + queriesIndirect)) * 100)) +"%",
                indirectPercentage = Math.round(((queriesIndirect / (queriesDirect + queriesIndirect)) * 100)) +"%";

            $chart.on('mouseover', '.highcharts-legend-item', function (){
                if ($(this).text().indexOf("Découverte") >= 0) {
                    $chart.find('.highcharts-title').html(`<tspan>Découverte</tspan><tspan x="294" dy="21">${queriesIndirect} (${indirectPercentage})</tspan>`);
                } else if ($(this).text().indexOf("Recherche directe") >= 0) {
                    $chart.find('.highcharts-title').html(`<tspan>Recherche directe</tspan><tspan x="294" dy="21">${queriesDirect} (${directPercentage})</tspan>`);
                }
            });

            $chart.on('mouseleave', '.highcharts-legend-item', function (){
                $chart.find('.highcharts-title').html(defaultHtml)
            } );
        },

        displayCharts: function(){
            var me = this;
            Highcharts.setOptions({
                global: {
                    useUTC: false
                },
                lang: appCustomerSpace.Modules.Charts.lang.t('highcharts')
            });

            $('.chart').each(function() {
                me.initHighcharts($(this));
            });

            $('.see-more-searchkeywords-btn').on('click', function() {
                $('tr.more-searchkeywords').show();
                $(this).hide();
            })
         },

        initHighcharts: function($container) {
            var $chart    = $container,
                chartType = $chart.data('chart-type'),
                options   = $chart.data('highcharts-options'),
                mainColor = $chart.data('main-color'),
                args      = undefined;

            switch(chartType) {
                case 'line':
                    options = $.extend(true, {
                        plotOptions: {
                        }
                    }, options);
                    break;
                case 'donut':
                    options = $.extend(true, {
                    }, options);
                    break;
                default:
                    throw 'Aucun type de diagramme n\'a été spécifié'
            }

            $.fn.highcharts.apply($chart, args ? args : [options]);
        },

        dateRangePicker: function(data) {
            var picker = new DateRangePicker($('#range-picker').show(), data, {
                ranges: this._ranges(data["min_date"], data["max_date"])
            }, function(start, end) {
                var $form = $('form.form-date-range-filter');
                $form.find('.start-date-input').val(start.format('YYYY-MM-DD'));
                $form.find('.end-date-input').val(end.format('YYYY-MM-DD'));
                $form.trigger('submit');
            });
        },

        _ranges: function(minDate, maxDate) {
            var me = this,
                ranges = {};

            ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.all')] = [moment(new Date(minDate)), moment(new Date(maxDate))]
            ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.thisWeek')] = [moment().startOf('isoWeek'), moment()];
            ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.lastWeek')] = [moment().startOf('isoWeek').subtract(1, 'week'), moment().subtract(1, 'week').endOf('isoWeek')];
            ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.twoWeeksAgo')] = [moment().startOf('isoWeek').subtract(2, 'week'), moment().subtract(2, 'week').endOf('isoWeek')];

            $.each([0, 1, 2, 3, 4], function(value) {
                var month = utils.capitalize(moment().subtract(value, 'month').format('MMMM YYYY'));
                ranges[month] = [moment().subtract(value, 'month').startOf('month'), (value == 0 ? moment() : moment().subtract(value, 'month').endOf('month'))];
            });

            ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.lastSemester')] = [moment().subtract(6, 'months').startOf('month'), moment().subtract(1, 'month').endOf('month')];
            ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.beforeLastSemester')] = [moment().subtract(1, 'year').startOf('month'), moment().subtract(7, 'months').endOf('month')];

            return ranges;
        }
    });

    return GoogleMyBusinessPerformanceController;

})(appCustomerSpace.Controllers.Statistics.MainController);
